import Vue from 'vue';
import Clubs from './components/Clubs';
import Results from './components/Results';
import {capitalize} from './helpers';
import {Menu} from './Menu';

const components = {
    results: Results,
    clubs: Clubs,
};

window.addEventListener('DOMContentLoaded', () => {
    new Menu(document.querySelector('#top-menu'));

    document.querySelectorAll('[data-component]').forEach(el => {
        const component = components[el.dataset.component];
        const props = {};
        for (const key in el.dataset) {
            if (key === 'component') {
                continue;
            }
            if (el.dataset.hasOwnProperty(key) && el.dataset[key]) {
                props['data' + capitalize(key)] = JSON.parse(el.dataset[key]);
            }
        }
        new Vue({
            el,
            render: h => h(component, {props}),
        });
    });
});
